import { getDefaultConfig } from '../../config/app-config';
import { RouteInterface, RoutesInterface } from '../../types/routes';
import { ctBrandedRoutes, getOnboardingRoutes } from '../../utils/apps';

// Will get overwritten by appConfig if available
const settings = getDefaultConfig().branding.ctlApp;
export const onboardingAppIcon = settings.logo;
export const onboardingAppName = settings.name;

const allRoutes = getOnboardingRoutes();
export const routeAppCode = `:onboardingPath(${allRoutes.join('|')})`;
const nonSGXRouteAppCode = `:onboardingPath(${ctBrandedRoutes.join('|')})`;

const companyTrackerOnboardingRoute: RouteInterface = {
  id: 'company_tracker',
  label: `${onboardingAppName} - Signup`,
  path: `/${routeAppCode}/onboarding/:activeStep?`,
  exact: false,
  icon: 'fa-cloud-sun',
}

const esgenomeOnboardingRoute: RouteInterface = {
  ...companyTrackerOnboardingRoute,
  path: '/:onboardingPath(sgx-esgenome)/onboarding',
}

const companyTrackerActivationRoute: RouteInterface = {
  id: 'company_tracker_activation',
  label: `${onboardingAppName} - Activation`,
  path: `/${nonSGXRouteAppCode}/onboarding/:activation(activate|incomplete)/:initiativeId/:surveyId/:token`,
  exact: true,
}

const esgenomeActivationRoute: RouteInterface = {
  ...companyTrackerActivationRoute,
  path: '/:onboardingPath(sgx-esgenome)/onboarding/:activation(activate|incomplete)/:initiativeId/:surveyId/:token',
}

const matOnboardingRoute: RouteInterface = {
  id: 'materiality_tracker_tool',
  label: 'Materiality Tracker - Signup',
  path: '/:onboardingPath(materiality-tracker)/onboarding/:activeStep?',
  exact: false,
};

const matActivationRoute: RouteInterface = {
  id: 'materiality_tracker_tool_activation',
  label: 'Materiality Tracker - Activation',
  path: '/:onboardingPath(materiality-tracker)/onboarding/:activation(activate|incomplete)/:initiativeId/:surveyId/:token',
  exact: true,
};

export const companyTrackerLightOnboardingRoutes: RoutesInterface = {
  COMPANY_TRACKER_ONBOARDING: companyTrackerOnboardingRoute,
  ESGENOME_ONBOARDING: esgenomeOnboardingRoute,
  MATERIALITY_TRACKER_ONBOARDING: matOnboardingRoute,
};

export const companyTrackerLightOnboardingActivationRoutes: RoutesInterface = {
  COMPANY_TRACKER_ONBOARDING_ACTIVATION: companyTrackerActivationRoute,
  ESGENOME_ONBOARDING_ACTIVATION: esgenomeActivationRoute,
  MATERIALITY_TRACKER_ONBOARDING_ACTIVATION: matActivationRoute,
};
